<div
  #popoverContainer
  popover="manual"
  class="toast-popover"
  role="status"
  aria-live="polite"
>
  @for (toast of toasts(); track toast.id) {
    <div
      [class]="
        'toast toast--' +
        toast.type +
        (toast.dismissing ? ' toast--leaving' : '') +
        (toast.paused ? ' toast--paused' : '')
      "
      (mouseenter)="pause(toast.id)"
      (mouseleave)="resume(toast.id)"
    >
      <mat-icon class="toast__icon">{{ iconMap[toast.type] }}</mat-icon>
      <div class="toast__content">
        @if (toast.title) {
          <span class="toast__title">{{ toast.title }}</span>
        }
        <span class="toast__message">{{ toast.message }}</span>
      </div>
      <button
        class="toast__close"
        aria-label="Dismiss"
        (click)="dismiss(toast.id)"
      >
        <mat-icon>close</mat-icon>
      </button>
      @for (_ of [toast.progressKey]; track _) {
        <div
          class="toast__progress"
          [style.animation-duration.ms]="toast.duration"
        ></div>
      }
    </div>
  }
</div>
